import React from "react";
import { useSelector, useDispatch } from "react-redux";
import classes from "./styles/style.module.css";
import CustomModal from "../../../assets/components/ModalComonent";
import CustomButton from "../../../assets/components/CustomButton";
import InfoImg from "../../../assets/images/common/InfoImg.png";
import { setShowWordGameHintModal } from "../../../assets/redux/actions/Quiz";
import { RiCheckDoubleLine } from "react-icons/ri";
import { FaCheck } from "react-icons/fa6";

const WordGameHintDialog = () => {
  const { showWordGamehintModal } = useSelector(({ quiz }) => quiz);
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setShowWordGameHintModal(false));
  };

  const modalContent = (
    <>
      <div className="w-100 text-center">
        <img src={InfoImg} alt="InfoIcon" className={classes.alertBanner} />
        <p className={classes.title}>راهنمای بازی </p>
        <div className={classes.dialogContent}>
          <p style={{ textAlign: "justify !important" }}>
            کلمه بازی یه بازی حدس کلمه که هر روز یه تعدادی کلمه ثابت برای حدس زدن
            داره. (پس جواب رو لو ندید 😄)
            <br />
            برای حدس زدن کافیه حروف مورد نظر خودتون رو بنویسید و “ثبت” را
            بزنید.بعد از هر حدس، هر کدوم از خونه‌های حدس شما سبز، زرد یا قرمز
            می‌شه تا برای حدس بعدی ازشون کمک بگیرید.
          </p>
          <div>
            <div className="d-flex align-items-center mt-2">
              <div className={classes.greenCheckContainer}>
                <RiCheckDoubleLine />
              </div>
              <p className="mr-2 mb-0">کاملا درسته.</p>
            </div>
            <div className="d-flex align-items-center mt-2">
              <div className={classes.orangeCheckContainer}>
                <FaCheck fontSize={11} />
              </div>
              <p className="mr-2 mb-0">جاشون اشتباهه.</p>
            </div>
            <div className="d-flex align-items-center mt-2">
              <div className={classes.redCheckContainer}></div>
              <p className="mr-2 mb-0">کاملاً اشتباهه.</p>
            </div>
          </div>
          <p className="mt-3" style={{ textAlign: "justify !important" }}>
            مثلاً اگه جواب روز وسواس و حدس شما سوسیس باشه:
          </p>
          <div className={classes.wordsContainer}>
            <div
              className={`${classes.wordContainer} ${classes.orangeContainer}`}
            >
              س
              <div className={classes.iconContainer}>
                <FaCheck fontSize={10} />
              </div>
            </div>
            <div
              className={`${classes.wordContainer} ${classes.orangeContainer}`}
            >
              <div className={classes.iconContainer}>
                <FaCheck fontSize={10} />
              </div>
              و
            </div>
            <div className={`${classes.wordContainer} ${classes.redContainer}`}>
              س
            </div>
            <div className={`${classes.wordContainer} ${classes.redContainer}`}>
              ی
            </div>
            <div
              className={`${classes.wordContainer} ${classes.greenContainer}`}
            >
              س
              <div className={classes.iconContainer}>
                <RiCheckDoubleLine fontSize={12} />
              </div>
            </div>
          </div>
          <p className="mt-3" style={{ textAlign: "justify !important" }}>
            اینکه حرف س رو به رنگ زرد و سبز و قرمز داریم، یعنی دو تا س توی جواب
            داریم، که جای یکیش درسته و اون یکی هم در خونهٔ ۲ یا ۴ باید جا بگیره.
            خوش بگذره :)
          </p>
        </div>
        <div className="w-75 mx-auto mt-4">
          <CustomButton
            clickHandler={handleClose}
            color={"primary"}
            shadow
            text={"بازگشت"}
          />
        </div>
      </div>
    </>
  );
  return (
    <CustomModal
      open={showWordGamehintModal}
      closeHandler={handleClose}
      inputDialog={true}
      dialogContent={modalContent}
    />
  );
};

export default WordGameHintDialog;
